export default __webpack_public_path__ + "41994471208dac497190e85cac1d7477.png";